import { useEffect, useRef } from 'react';

let lockCount = 0;
let originalBodyStyle = '';

export const useScrollLock = (isLocked: boolean) => {
  const isLockedRef = useRef(isLocked);

  useEffect(() => {
    isLockedRef.current = isLocked;

    if (isLocked) {
      // Increment lock count
      lockCount++;
      
      // Only apply lock on first modal
      if (lockCount === 1) {
        // Store original body styles
        originalBodyStyle = document.body.style.overflow;
        
        // Get current scroll position
        const scrollY = window.scrollY;
        
        // Lock the body scroll
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = '100%';
      }
    } else {
      // Decrement lock count
      lockCount = Math.max(0, lockCount - 1);
      
      // Only unlock when no modals are open
      if (lockCount === 0) {
        // Get the scroll position from the body's top style
        const scrollY = parseInt(document.body.style.top || '0') * -1;
        
        // Restore original body styles
        document.body.style.overflow = originalBodyStyle;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        
        // Restore scroll position
        window.scrollTo(0, scrollY);
      }
    }

    // Cleanup function
    return () => {
      if (isLockedRef.current) {
        lockCount = Math.max(0, lockCount - 1);
        
        if (lockCount === 0) {
          const scrollY = parseInt(document.body.style.top || '0') * -1;
          
          document.body.style.overflow = originalBodyStyle;
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';
          
          window.scrollTo(0, scrollY);
        }
      }
    };
  }, [isLocked]);
};